export default
`
Science and art are humanity’s greatest tools to define the world around us, but the two are often said to be polar opposites. As both an artist and a scientist, Patricia believes that the two fields are the same. A huge amount of creativity is needed to uncover the secrets of the human body, and art provides a powerful medium to describe, understand, and relate to science on a personal level. In this collection of pieces, Patricia explores complex systems in the human body at the cutting edge of scientific research.
`


// WEBPACK FOOTER //
// ./src/content/the-art-of-communicating-science.js